export default "__VITE_ASSET__b0b8b280__"